export interface ILateBloodDrawFilter {
    surgeryDateFrom?: string,
    surgeryDateTo?: string,
    centerId?: number,
    donorCenterId?: number,
    recipientCenterId?: number
}
